import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) =>{

  const darkMode = mode === 'dark'

  return createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(4),
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      '.Mui-expanded & ': {
        fontWeight: 'bold',
      },
    },

    modelTable: {
      '& a, & a:visited': {
        color: darkMode
          ? theme.palette.primary.light
          : theme.palette.primary.main
        ,
      },
    },

    magazineGrid: {
      display: 'grid',
      gap: theme.spacing(2),
      gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
    },

    magazineCard: {
      background: darkMode ? 'rgba(255, 255, 255, .04)' : '#fff',
      border: `1px solid ${darkMode ? 'rgba(255, 255, 255, .12)' : 'rgba(0, 0, 0, .08)'}`,
      boxShadow: darkMode ? 'none' : '0 12px 30px rgba(0, 0, 0, .08)',
      color: 'inherit',
      cursor: 'pointer',
      display: 'grid',
      gap: theme.spacing(1.25),
      gridTemplateRows: 'auto 1fr',
      padding: theme.spacing(1),
      textAlign: 'left',
      textDecoration: 'none',
      width: '100%',
      '&:hover': {
        transform: 'translateY(-2px)',
      },
    },

    magazineCover: {
      aspectRatio: '3 / 4',
      background: darkMode ? 'rgba(255, 255, 255, .06)' : '#f2eee7',
      display: 'grid',
      overflow: 'hidden',
      placeItems: 'center',
      position: 'relative',
      '& img': {
        height: '100%',
        objectFit: 'cover',
        width: '100%',
      },
      '& > span': {
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontSize: '1.4rem',
        padding: theme.spacing(2),
        textAlign: 'center',
      },
    },

    magazineMeta: {
      display: 'grid',
      gap: theme.spacing(.35),
      '& small, & em, & span': {
        color: darkMode ? 'rgba(255, 255, 255, .68)' : 'rgba(0, 0, 0, .58)',
        fontStyle: 'normal',
      },
      '& strong': {
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontSize: '1.15rem',
        lineHeight: 1.05,
      },
    },

    magazineFaq: {
      display: 'grid',
      gap: theme.spacing(2),
    },

    magazineFaqIntro: {
      color: darkMode ? 'rgba(255, 255, 255, .72)' : 'rgba(0, 0, 0, .62)',
      margin: 0,
    },

    magazineFaqItem: {
      borderBottom: `1px solid ${darkMode ? 'rgba(255, 255, 255, .12)' : 'rgba(0, 0, 0, .08)'}`,
      display: 'grid',
      gap: theme.spacing(.7),
      paddingBottom: theme.spacing(1.5),
      '& small': {
        color: darkMode ? 'rgba(255, 255, 255, .54)' : 'rgba(131, 116, 94, .92)',
        fontSize: '.75rem',
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
      },
      '& h3': {
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontSize: '1.25rem',
        lineHeight: 1.15,
        margin: 0,
      },
      '& div': {
        display: 'grid',
        gap: theme.spacing(.75),
      },
      '& p': {
        lineHeight: 1.62,
        margin: 0,
      },
      '& a': {
        color: darkMode ? theme.palette.primary.light : theme.palette.primary.main,
        fontWeight: 800,
        justifySelf: 'start',
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },

    brandDetails: {
      display: 'grid',
      gap: theme.spacing(2),
    },

    brandDetailsHeader: {
      alignItems: 'center',
      display: 'grid',
      gap: theme.spacing(2),
      gridTemplateColumns: 'minmax(120px, 180px) minmax(0, 1fr)',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },

    brandDetailsLogo: {
      alignItems: 'center',
      background: darkMode ? 'rgba(255, 255, 255, .04)' : '#fff',
      border: `1px solid ${darkMode ? 'rgba(255, 255, 255, .12)' : 'rgba(0, 0, 0, .08)'}`,
      display: 'flex',
      justifyContent: 'center',
      minHeight: 92,
      padding: theme.spacing(1.5),
      '& img': {
        display: 'block',
        maxHeight: 64,
        maxWidth: '100%',
        objectFit: 'contain',
      },
    },

    brandDetailsText: {
      display: 'grid',
      gap: theme.spacing(.75),
      '& strong': {
        fontSize: '1.1rem',
      },
      '& a': {
        color: darkMode ? theme.palette.primary.light : theme.palette.primary.main,
        fontWeight: 700,
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },

    brandDescription: {
      '& p:first-child': {
        marginTop: 0,
      },
      '& p:last-child': {
        marginBottom: 0,
      },
    },

    manufacturerAddress: {
      borderTop: `1px solid ${darkMode ? 'rgba(255, 255, 255, .12)' : 'rgba(0, 0, 0, .08)'}`,
      color: darkMode ? 'rgba(255, 255, 255, .74)' : 'rgba(0, 0, 0, .66)',
      paddingTop: theme.spacing(1.5),
    },
  })
})

export default useStyles
